'use client';

/**
 * Emergency patch for localStorage to handle quota errors
 * This overrides the original localStorage methods to catch quota errors
 * without causing exceptions in the UI
 */

if (typeof window !== 'undefined') {
  try {
    console.log('Patching localStorage methods to prevent quota errors');
    
    // Original setItem method
    const originalSetItem = localStorage.setItem;
    
    // Override setItem to catch quota errors
    localStorage.setItem = function(key, value) {
      try {
        // Try to use the original method
        originalSetItem.apply(this, [key, value]);
      } catch (error) {
        // If it's a quota error, handle gracefully
        if (error && error.name === 'QuotaExceededError') {
          // Only warn for non-backup keys that are likely critical
          if (!key.includes('backup') && !key.includes('_exists') && key !== 'order') {
            console.warn(`QuotaExceededError for key ${key} - value not saved`);
          }

          // For order data, try to store a minimal version with just essential fields
          if (key === 'order') {
            try {
              const orderData = JSON.parse(value);
              const minimalOrder = {
                id: orderData.id,
                orderNumber: orderData.orderNumber,
                bookId: orderData.bookId,
                format: orderData.format,
                totalAmount: orderData.totalAmount,
                status: orderData.status
              };
              originalSetItem.apply(this, ['order_minimal', JSON.stringify(minimalOrder)]);
            } catch (innerError) {
              // If parsing or minimal storage fails, just skip silently
            }
          }

          // For critical data, try setting a shortened version
          if (key.includes('storyPages') || key.includes('StoryPages')) {
            // Try again with a small marker
            try {
              originalSetItem.apply(this, [`${key}_exists`, 'true']);
            } catch (innerError) {
              // Ignore inner errors
            }
          }
        } else {
          // For other errors, rethrow
          throw error;
        }
      }
    };
    
    console.log('localStorage patched successfully');
  } catch (error) {
    console.error('Error patching localStorage:', error);
  }
}
